import script from "./RealtimeData.vue?vue&type=script&setup=true&lang=js"
export * from "./RealtimeData.vue?vue&type=script&setup=true&lang=js"

import "./RealtimeData.vue?vue&type=style&index=0&id=7ca5dd13&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ca5dd13"]])

export default __exports__